// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"0067f155","545":"163b7aed"}[chunkId] + ".chunk.js";
};